import React, {useEffect} from "react";

import type {ContextMenuInterface} from "../../ContextMenuInterface";


import {TriggerActions} from "./TriggerActions";
import {TriggerMentions} from "./TriggerMentions";
import {TriggerEmojis} from "./TriggerEmojis";
import {hotkeys, HOTKEYS_SCOPE} from "../../../../../utils/hotkeys";


import { editorViewRef } from '../../../EditorReact';


export type TriggerType = 'actions' | 'emojis' | 'mentions';

export interface TriggerToolbarProps extends ContextMenuInterface {
    textInput: string;
    trigger: TriggerType;
    nodePos: number;
    isTriggerInline?: boolean;
}


export const TriggerToolbar = ({handleClose, trigger, textInput, isDark, isTriggerInline = false, nodePos}: TriggerToolbarProps) => {
    const view = editorViewRef.current;

    useEffect(() => {
        hotkeys(
            'Escape',
            {
                scope: HOTKEYS_SCOPE.EDITOR,
                keydown: true,
            },
            () => handleClose(),
        )
        return () => {
            hotkeys.unbind('Escape', HOTKEYS_SCOPE.EDITOR);
        }
    }, [handleClose]);

    if (view === null) {
        return  null;
    }

    switch (trigger) {
        case "actions":
            return <TriggerActions textInput={textInput} handleClose={handleClose} isDark={isDark} isTriggerInline={isTriggerInline} nodePos={nodePos}/>
        case "mentions":
            return <TriggerMentions textInput={textInput} handleClose={handleClose} isDark={isDark} isTriggerInline={isTriggerInline} nodePos={nodePos}/>
        case "emojis":
            return <TriggerEmojis/>
    }
}
